import * as React from "react"
import Map from './svg/Habitat-minerer.svg'

const SvgComponent = (props) => (
  <img src={Map} alt="Florida" {...props} />
)
export default SvgComponent
